<template>
  <div id="apppdf">
    <div id="pdf"></div>
    <div class="dowpdf" @click="downloadFile(currentValue.dow, currentValue.title)"></div>
  </div>
</template>
<script>
  import Pdfh5 from "pdfh5";
  import Download from "../../../static/download.js";

  export default {
    // meta: [
    //   { charset: 'utf-8' },
    //   { name: 'viewport', content: 'width=device-width,initial-scale=1, maximum-scale=2, user-scalable=yes' }
    // ],
    props: {
      value: {
        type: Object
      },
    },
    name: 'apppdf',
    data() {
      return {
        pdfh5: null,
        currentValue: {},
      };
    },
    watch: {
      value(val) {
        // console.log('abc', this.value)
        // console.log('val', val)
        if (this.currentValue.dow != val.dow) {
          this.currentValue = val
          this.pdf(this.currentValue.dow)
        }
      },
    },
    mounted() {
      // console.log('第一次', this.value)
      this.currentValue = this.value
      this.pdf(this.value.dow)
    },
    methods: {
      downloadFile(url, name){
    	   Download(url, name)
  	  },
        //实例化
      pdf(e) {
        // console.log('e', e )
        this.pdfh5 = new Pdfh5("#pdf", {
          pdfurl: e,
          // lazy: true,
          backTop: false,
          scale: 2,
        })
        //监听完成事件
        this.pdfh5.on("complete", function (status, msg, time) {
          // console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
          console.log( time + "s , page:" + this.totalNum)
        })
      }
    }
  }
</script>
 
<style>
    @import "pdfh5/css/pdfh5.css";
    #apppdf {
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/untils/pdf/pdf.vue